import React, {createContext} from "react";

const toggleContext = createContext(null);

export default function getToggleContext()
{
    return toggleContext;
}
